import { Provider } from "react-redux";
import "react-responsive-modal/styles.css";
import "./App.css";

import "babel-polyfill";
import "fullpage-react-fs/dist/index.css";
import { Toaster } from "react-hot-toast";
import { HashRouter } from "react-router-dom";
import { store } from "reduxFun/store";
import AppRouter from "./components/app-router/AppRouter.component";

import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { AuthProvider } from "@ui/components/AuthProvider";
import AppWrapper from "components/app-wrapper/AppWrapper.component";
import ErrorBoundary from "components/error-boundary/ErrorBoundary.component";
import { PhotoProvider } from "react-photo-view";
import { ParallaxProvider } from "react-scroll-parallax";
import { theme } from "utils/global-theme.util";
import { AppContextProvider } from "./store/index";

function App() {
  return (
    // <SplashScreen>
    <AppContextProvider>
      <Provider store={store}>
        <Toaster position="top-right" />
        <HashRouter>
          <ParallaxProvider>
            <StyledEngineProvider injectFirst>
              <MuiThemeProvider theme={theme}>
                <ErrorBoundary>
                  <AuthProvider>
                    <PhotoProvider maskOpacity={0.5}>
                      <AppWrapper>
                        <AppRouter />
                      </AppWrapper>
                    </PhotoProvider>
                  </AuthProvider>
                </ErrorBoundary>
              </MuiThemeProvider>
            </StyledEngineProvider>
          </ParallaxProvider>
        </HashRouter>
      </Provider>
    </AppContextProvider>
    // </SplashScreen>
  );
}

export default App;
